import { useState, useEffect } from 'react'
import Card from '../components/Card'

const units = {
  mm: { name: 'Millimeter', factor: 0.001 },
  cm: { name: 'Centimeter', factor: 0.01 },
  m: { name: 'Meter', factor: 1 },
  km: { name: 'Kilometer', factor: 1000 },
  in: { name: 'Inch', factor: 0.0254 },
  ft: { name: 'Foot', factor: 0.3048 },
  yd: { name: 'Yard', factor: 0.9144 },
  mi: { name: 'Mile', factor: 1609.34 },
}

export default function LengthConverter() {
  const [fromUnit, setFromUnit] = useState('cm')
  const [toUnit, setToUnit] = useState('m')
  const [fromValue, setFromValue] = useState('')
  const [toValue, setToValue] = useState('')

  const convert = () => {
    if (!fromValue || isNaN(fromValue)) {
      setToValue('')
      return
    }

    const value = parseFloat(fromValue)
    const fromFactor = units[fromUnit].factor
    const toFactor = units[toUnit].factor

    const meters = value * fromFactor
    const result = meters / toFactor

    setToValue(result.toFixed(6).replace(/\.?0+$/, ''))
  }

  useEffect(() => {
    convert()
  }, [fromUnit, toUnit, fromValue])

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="label">From:</label>
              <select
                value={fromUnit}
                onChange={(e) => {
                  setFromUnit(e.target.value)
                  convert()
                }}
                className="input w-full mb-2"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>
                    {unit.name} ({key})
                  </option>
                ))}
              </select>
              <input
                type="number"
                value={fromValue}
                onChange={(e) => {
                  setFromValue(e.target.value)
                  convert()
                }}
                className="input w-full"
                placeholder="Enter value"
                step="0.01"
              />
            </div>
            <div>
              <label className="label">To:</label>
              <select
                value={toUnit}
                onChange={(e) => {
                  setToUnit(e.target.value)
                  convert()
                }}
                className="input w-full mb-2"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>
                    {unit.name} ({key})
                  </option>
                ))}
              </select>
              <input
                type="number"
                value={toValue}
                readOnly
                className="input w-full bg-gray-50"
                placeholder="Result"
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

